import ExamsFaqSection from "@/components/exams/exams-faq-section";
import SeoMeta from "@/components/seo-meta";
import data from "@/data/setup.json";
import { buildMedicalBusinessJsonLd } from "@/lib/seo-data";

export default function ExamsFaqPage() {
	return (
		<>
			<SeoMeta
				title={`Exames e Dúvidas | ${data.cliente.nome}`}
				description={data["area-exames"]["texto-1"]}
				canonicalPath="/exames-duvidas"
				jsonLd={buildMedicalBusinessJsonLd(data)}
			/>
			<ExamsFaqSection data={data} />
		</>
	);
}
